import { render, staticRenderFns } from "./ModalQuickBuy.vue?vue&type=template&id=2ba239f0"
import script from "./ModalQuickBuy.vue?vue&type=script&lang=js"
export * from "./ModalQuickBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseModal: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseModal.vue').default})
